import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import { BiSolidError } from "react-icons/bi";
import { IoCloseSharp } from "react-icons/io5";
import { RiDeleteBin6Fill, RiEditFill } from "react-icons/ri";
import { BsCalendarCheck } from "react-icons/bs";
import { MdOutlineCancel, MdOutlineEdit } from "react-icons/md";
import ActionMenu from "../../../../component/ActionMenu";
import { TbFilterSearch } from "react-icons/tb";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getStatusBadge,
  getStatusText,
} from "../../../../component/admin/VehiclesTable";
import BusCharter from "../../../../component/Model/reservation/BusCharter";
import CancelReservation from "../../../../component/Model/reservation/CancelReservation";
import FilterComponent from "../../../../component/Model/reservation/FilterComponent";
import AdminPagination from "../../../../component/pagination/AdminPagination";
import SkeletonLoading from "../../../../component/SkeletonLoading";
import Tooltip from "../../../../component/Tooltip";
import i18n from "../../../../i8next";
import {
  useDeleteReservationMutation,
  useGetAllReservationsQuery,
  useUpdateReservationMutation,
} from "../../../../store/api/school/ReservationSlice";
import UnassignDriverModal from "../../../../component/Model/reservation/UnassignDriverModal";
import { multiPartData2 } from "../../../../utils";
import {
  convertTime,
  formatDateToLocal,
} from "../../../../utils/dateAndTimeConversion";
import BusCharterAssignDriver from "../BusCharterAssignDriver";

const initialPagination = {
  limit: 10,
  page: 1,
  total: "",
  totalPages: "",
};

const BusCharterList = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [editModelShow, setEditModelShow] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [bookingCancelModal, setBookingCancelModal] = useState(false);
  const [id, setId] = useState("");
  const [bookingCancelId, setBookingCancelId] = useState("");
  const handleCloseBookingCancelModal = () => setBookingCancelModal(false);
  const handleEditModelClose = () => setEditModelShow(false);
  const handleCloseDetail = () => setShowDetail(false);
  const [selectedReservation, setSelectedReservation] = useState(null);
  const [bookingDetails, setBookingDetails] = useState({});
  const [reservations, setReservations] = useState([]);

  const [filters, setFilters] = useState({});
  const [pagination, setPagination] = useState(initialPagination);

  const { user } = useSelector((state) => state.UserReducer);
  const role = user?.role;

  // slug
  const { slug } = useParams();

  const [showCancelModal, setShowCancelModal] = useState(false);
  const handleCloseCancelModal = () => setShowCancelModal(false);
  const [reservationId, setReservationId] = useState(null);
  const [charterFrequency, setCharterFrequency] = useState("");

  const [open, setOpen] = useState(false);

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllReservationsQuery({
      endPoint: "bus-charter/transferred",
      page: pagination.page,
      limit: pagination.limit,
      ...filters,
      role: "vendor",
    });

  // delete query
  const [deleteReservation, { isLoading: isDeleteLoading }] =
    useDeleteReservationMutation();

  const [updateReservation, { isLoading: isUpdateLoading }] =
    useUpdateReservationMutation();

  useEffect(() => {
    if (isSuccess && data?.data) {
      setReservations(data.data.reservations);
      setPagination(data.data.pagination);
    }
  }, [data, isSuccess]);

  // model show function
  const handleShow = (id) => {
    setShow(true);
    setId(id);
  };

  // delete function
  const handleDelete = async () => {
    toast.dismiss();
    try {
      const response = await deleteReservation({
        endPoint: "bus-charter",
        id,
      }).unwrap();
      if (response.statusCode === 200) {
        toast.success(response.message);
        setShow(false);
        setId("");
      }
    } catch (err) {
      const mesg = err.data?.message || "Something went wrong";
      toast.error(mesg);
    }
  };

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, page }));
  };

  const handleLimitChange = (limit) => {
    setPagination((prev) => ({
      ...prev,
      limit,
      page: 1,
    }));
  };

  const handleApplyFilters = (data) => {
    setFilters(data);
    setOpen(false);
  };
  const handleResetFilters = () => {
    setFilters({});
    setPagination(initialPagination);
  };

  const handleShowEditModel = (item) => {
    setSelectedReservation(item);
    setEditModelShow(true);
  };

  const handleBookingDetails = (item) => {
    setBookingDetails(item);
    setShowDetail(true);
  };

  const handleCancelled = (id) => {
    setBookingCancelModal(true);
    setBookingCancelId(id);
  };

  const handleRideCancel = async (e) => {
    e.preventDefault();
    toast.dismiss();

    const formdatas = multiPartData2({ status: "cancelled" });

    try {
      let response = await updateReservation({
        data: formdatas,
        id: bookingCancelId,
      }).unwrap();

      if (response.statusCode === 200 || response.statusCode === 201) {
        toast.success(response.message);
        setBookingCancelModal(false);
        setBookingCancelId("");
      }
    } catch (err) {
      const mesg = err.data?.message || "Something went wrong";
      toast.error(mesg);
    }
  };

  // Language Change Handler
  useEffect(() => {
    const h = () => {
      refetch?.();
    };
    i18n.on("languageChanged", h);
    return () => i18n.off("languageChanged", h);
  }, [refetch]);

  // Helper function to format text
  const formatText = (text) => {
    if (!text) return "";
    return text.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const [showUnassignConfirm, setShowUnassignConfirm] = useState(false);

  const handleCancelReservation = (data) => {
    setShowCancelModal(false);
    setShowDetail(false);
    refetch();
  };

  // useEffect(() => {
  //   if (isAdmin) {
  //     const role = slug === "school-bus-charter" ? "school" : "vendor";
  //     setFilters((prev) => ({ ...prev, role }));
  //   }
  // }, [slug, role]);

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between">
        <div className="mb-2 total">
          {t("total")} {t("reservations")}: {pagination?.total}
        </div>

        <div className="mb-2 filterBox">
          <ul className="d-flex flex-wrap align-items-center p-0 transactionsFilter">
            {role === "school" && (
              <NavLink to="/bus-charter-reservations/vendors">
                <Button className="searchBtn">{t("btns.reserve")}</Button>
              </NavLink>
            )}

            <li>
              <button
                type="button"
                className={`btn ${
                  open ? "btn-primary" : "btn-primary"
                } d-flex align-items-center gap-2`}
                onClick={() => setOpen(!open)}
              >
                {open ? (
                  <>
                    <TbFilterSearch /> {t("btns.hide")} {t("btns.filters")}
                  </>
                ) : (
                  <>
                    <TbFilterSearch /> {t("show")} {t("btns.filters")}
                  </>
                )}
              </button>
            </li>
          </ul>
        </div>
      </div>

      <FilterComponent
        open={open}
        role="school"
        onReset={handleResetFilters}
        handleApplyFilters={handleApplyFilters}
      />

      <div className="table m-0">
        <table>
          <thead>
            <tr>
              <th className="text-nowrap">
                {t("Sr")}.{t("no")}.
              </th>
              <th className="text-nowrap">
                {t("driver")} {t("name")}
              </th>
              <th className="text-nowrap">
                {t("booking")} {t("type")}
              </th>
              <th className="text-nowrap">
                {t("charter")} {t("type")}
              </th>
              <th className="text-nowrap">
                {t("vehicle")} {t("type")}
              </th>
              <th className="text-nowrap">
                {t("vehicle")} {t("license")} {t("plate")}
              </th>
              <th>{t("rate")}</th>
              <th className="text-nowrap">
                {t("start")} {t("date")}
              </th>
              <th className="text-nowrap">
                {t("end")} {t("date")}
              </th>
              <th className="text-nowrap">
                {t("start")} {t("time")}
              </th>
              {/* <th className="text-nowrap">
                {t("end")} {t("time")}
              </th> */}
              <th className="text-nowrap">
                {t("reserved")} {t("seats")}
              </th>
              <th>{t("status")}</th>
              {role === "vendor" && (
                <th className="text-nowrap">
                  {t("assign")} {t("driver")}
                </th>
              )}
              <th>{t("action")}</th>
            </tr>
          </thead>
          <tbody>
            {isLoading || isFetching ? (
              <SkeletonLoading
                MainLength={10}
                length={role === "vendor" ? 15 : 14}
              />
            ) : reservations?.length > 0 ? (
              reservations?.map((item, i) => (
                <tr key={i}>
                  <td>{(pagination.page - 1) * pagination.limit + i + 1}</td>
                  <td>{item?.driver?.full_name || "Unassigned"}</td>
                  <td className="text-nowrap">
                    {formatText(item?.booking_type)}
                  </td>
                  <td className="text-nowrap">
                    {formatText(item?.charter_type)}
                  </td>
                  <td className="text-nowrap">
                    {item?.vehicle?.vehicle_type_name}
                  </td>
                  <td>{item?.vehicle?.license_number}</td>
                  <td className="text-nowrap">${item?.fare_rate || 0}</td>
                  <td className="text-nowrap">
                    {formatDateToLocal(item?.start_date)}
                  </td>
                  <td className="text-nowrap">
                    {item?.end_date ? formatDateToLocal(item?.end_date) : "N/A"}
                  </td>
                  <td className="text-nowrap">
                    <div>
                      <small className="text-muted me-1">
                        {item?.charter_type === "return_trip"
                          ? t("return")
                          : t("outgoing")}{" "}
                        :
                      </small>
                      {convertTime(item?.start_time) || "—"} –{" "}
                      {convertTime(item?.end_time) || "—"}
                    </div>
                    {item?.charter_type === "round_trip" &&
                      item?.return_start_time && (
                        <div className="mt-1">
                          <small className="text-muted me-1">
                            {t("return")}:
                          </small>
                          {convertTime(item.return_start_time)} –{" "}
                          {convertTime(item.return_end_time)}
                        </div>
                      )}
                  </td>
                  <td>{item?.reserved_seats}</td>
                  <td>
                    <span className={getStatusBadge(item?.status)}>
                      {getStatusText(item?.status)}
                    </span>
                  </td>

                  {role === "vendor" && (
                    <td>
                      {item.status !== "pending" ? (
                        "__"
                      ) : (
                        <BusCharterAssignDriver bookingId={item?.id} />
                      )}
                    </td>
                  )}

                  <td>
                    <div className="actionBtn d-flex">
                      <ActionMenu
                        actions={[
                          {
                            label: `${t("reservation")} ${t("details")}`,
                            icon: <BsCalendarCheck />,
                            onClick: () => handleBookingDetails(item),
                          },
                          ...(role === "school"
                            ? [
                                {
                                  label: `${t("edit")}`,
                                  icon: <MdOutlineEdit size={16} />,
                                  onClick: () => handleShowEditModel(item),
                                  disabled: item?.status === "cancelled",
                                },
                                {
                                  label: `${t("cancel")} ${t("reservations")}`,
                                  icon: <MdOutlineCancel size={16} />,
                                  onClick: () => {
                                    setReservationId(item.id);
                                    setCharterFrequency(item.charter_frequency);
                                    setShowCancelModal(true);
                                  },
                                  disabled: item?.status === "cancelled",
                                },
                                {
                                  label: `${t("delete")}`,
                                  icon: <RiDeleteBin6Fill />,
                                  onClick: () => handleShow(item.id),
                                  danger: true,
                                  hidden: ![
                                    "cancelled",
                                    "completed",
                                    "pending",
                                  ].includes(item?.status),
                                },
                              ]
                            : []),
                        ]}
                      />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="text-center">
                <td colSpan="17">
                  <div>
                    <span>
                      {t("no")} {t("reservation")} {t("found")}
                    </span>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <AdminPagination
        totalPages={pagination.totalPages}
        currentPage={pagination.page}
        limit={pagination.limit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
      />

      {/* Booking Details Modal */}
      <Modal
        show={showDetail}
        onHide={handleCloseDetail}
        size="lg"
        centered
        backdrop="static"
        className="detailModel"
      >
        <Modal.Header closeButton className="border-0 position-relative">
          <Modal.Title className="w-100 text-center">
            <h4 className="mb-0 fw-bold text-white">
              <i className="fas fa-bus me-2"></i>
              {t("reservation")} {t("details")}
            </h4>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="pt-0"
          style={{
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <div className="reservation-details-container">
            {/* Header Card with Status */}
            <div className="header-card mb-4 mt-2">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="reservation-id">
                    <span className="badge bg-light text-dark fs-6">
                      <i className="fas fa-hashtag me-2"></i>
                      {t("booking")} {t("ID")}:{" "}
                      <strong>{bookingDetails?.id || "N/A"}</strong>
                    </span>
                  </div>
                  {/* <h5 className="mt-2 fw-bold text-dark">
                    {bookingDetails?.school?.company_name || "N/A"}
                  </h5> */}
                </div>
                <div>
                  <span className={getStatusBadge(bookingDetails?.status)}>
                    {getStatusText(bookingDetails?.status)}
                  </span>
                </div>
              </div>
            </div>

            {/* Main Information Grid */}
            <div className="info-grid mb-4">
              <div className="row">
                {/* Left Column */}
                <div className="col-md-6">
                  {bookingDetails?.school && (
                    <div className="info-card mb-3">
                      <div className="info-header">
                        <i className="fas fa-calendar-alt me-2 text-primary"></i>
                        <h6 className="mb-0 fw-bold">
                          {t("school")} {t("information")}
                        </h6>
                      </div>
                      <div className="info-body">
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-tag me-2"></i>
                            {t("full")} {t("name")}:
                          </span>
                          <span className="info-value">
                            {bookingDetails?.school?.full_name}
                          </span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-tag me-2"></i>
                            {t("email")}:
                          </span>
                          <span className="info-value">
                            {bookingDetails?.school?.email}
                          </span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-bus me-2"></i>
                            {t("company")} {t("name")}:
                          </span>
                          <span className="info-value">
                            {bookingDetails?.school?.company_name}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="info-card mb-3">
                    <div className="info-header">
                      <i className="fas fa-calendar-alt me-2 text-primary"></i>
                      <h6 className="mb-0 fw-bold">
                        {t("booking")} {t("information")}
                      </h6>
                    </div>
                    <div className="info-body">
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-tag me-2"></i>
                          {t("booking")} {t("type")}:
                        </span>
                        <span className="info-value">
                          {formatText(bookingDetails?.booking_type)}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-road me-2"></i>
                          {t("charter")} {t("type")}:
                        </span>
                        <span className="info-value">
                          {formatText(bookingDetails?.charter_type)}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-redo me-2"></i>
                          {t("frequency")}:
                        </span>
                        <span className="info-value">
                          {formatText(bookingDetails?.charter_frequency)}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="info-card mb-3">
                    <div className="info-header">
                      <i className="fas fa-bus me-2 text-primary"></i>
                      <h6 className="mb-0 fw-bold">
                        {t("vehicle")} {t("details")}
                      </h6>
                    </div>
                    <div className="info-body">
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-car me-2"></i>
                          {t("vehicle")} {t("type")}:
                        </span>
                        <span className="info-value">
                          {bookingDetails?.vehicle?.vehicle_type_name || "N/A"}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-id-card me-2"></i>
                          {t("license")} {t("plate")}:
                        </span>
                        <span className="info-value">
                          {bookingDetails?.vehicle?.license_number || "N/A"}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-users me-2"></i>
                          {t("reserved")} {t("seats")}:
                        </span>
                        <span className="info-value">
                          {bookingDetails?.reserved_seats || 0}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Column */}
                <div className="col-md-6">
                  {bookingDetails?.vendor && (
                    <div className="info-card mb-3">
                      <div className="info-header">
                        <i className="fas fa-user-tie me-2 text-primary"></i>
                        <h6 className="mb-0 fw-bold">
                          {t("vendor")} {t("information")}
                        </h6>
                      </div>
                      <div className="info-body">
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-user me-2"></i>
                            {t("full")} {t("name")}:
                          </span>
                          <span className="info-value">
                            {bookingDetails?.vendor?.full_name || "N/A"}
                          </span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-user me-2"></i>
                            {t("email")}:
                          </span>
                          <span className="info-value">
                            {bookingDetails?.vendor?.email || "N/A"}
                          </span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-user me-2"></i>
                            {t("company")} {t("name")}:
                          </span>
                          <span className="info-value">
                            {bookingDetails?.vendor?.company_name || "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="info-card mb-3">
                    <div className="info-header">
                      <i className="fas fa-user-tie me-2 text-primary"></i>
                      <h6 className="mb-0 fw-bold">
                        {t("driver")} & {t("rate")}
                      </h6>
                    </div>
                    <div className="info-body">
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-user me-2"></i>
                          {t("driver")}:
                        </span>
                        <span
                          className={`info-value ${
                            !bookingDetails?.driver?.full_name
                              ? "text-warning"
                              : ""
                          }`}
                        >
                          {bookingDetails?.driver?.full_name || t("unassigned")}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-money-bill-wave me-2"></i>
                          {t("email")}:
                        </span>
                        <span>{bookingDetails?.driver?.email || "__"}</span>
                      </div>
                    </div>
                  </div>

                  <div className="info-card mb-3">
                    <div className="info-header">
                      <i className="fas fa-clock me-2 text-primary"></i>
                      <h6 className="mb-0 fw-bold">{t("schedule")}</h6>
                    </div>
                    <div className="info-body">
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-calendar-day me-2"></i>
                          {t("start")} {t("date")}:
                        </span>
                        <span className="info-value">
                          {formatDateToLocal(bookingDetails?.start_date)}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-calendar-day me-2"></i>
                          {t("end")} {t("date")}:
                        </span>
                        <span className="info-value">
                          {bookingDetails?.end_date
                            ? formatDateToLocal(bookingDetails?.end_date)
                            : "N/A"}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-clock me-2"></i>
                          {bookingDetails?.charter_type === "return_trip"
                            ? t("return")
                            : t("outgoing")}{" "}
                          {t("start")} {t("time")}:
                        </span>
                        <span className="info-value">
                          {convertTime(bookingDetails?.start_time)}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-clock me-2"></i>
                          {bookingDetails?.charter_type === "return_trip"
                            ? t("return")
                            : t("outgoing")}{" "}
                          {t("end")} {t("time")}:
                        </span>
                        <span className="info-value">
                          {convertTime(bookingDetails?.end_time)}
                        </span>
                      </div>
                      {bookingDetails?.return_start_time && (
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-clock me-2"></i>
                            {t("return")} {t("start")} {t("time")}:
                          </span>
                          <span className="info-value">
                            {convertTime(bookingDetails.return_start_time)}
                          </span>
                        </div>
                      )}
                      {bookingDetails?.return_end_time && (
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-clock me-2"></i>
                            {t("return")} {t("end")} {t("time")}:
                          </span>
                          <span className="info-value">
                            {convertTime(bookingDetails.return_end_time)}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Location Information */}
            <div className="location-section mb-4">
              <div className="row">
                <div className="col-md-6">
                  <div className="location-card pickup">
                    <div className="location-header bg-success text-white">
                      <i className="fas fa-map-marker-alt me-2"></i>
                      {t("pickup")} {t("location")}
                    </div>
                    <div className="location-body">
                      <p className="mb-0">
                        <i className="fas fa-location-dot text-danger me-2"></i>
                        {bookingDetails?.pickup_address || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="location-card destination">
                    <div className="location-header bg-success text-white">
                      <i className="fas fa-flag-checkered me-2"></i>
                      {t("destination")}
                    </div>
                    <div className="location-body">
                      <p className="mb-0">
                        <i className="fas fa-map-pin text-success me-2"></i>
                        {bookingDetails?.destination_address || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Notes Section */}
            {bookingDetails?.notes && (
              <div className="notes-section mb-4">
                <div className="notes-card">
                  <div className="notes-header">
                    <i className="fas fa-sticky-note me-2 text-info"></i>
                    <h6 className="mb-0 fw-bold">{t("notes")}</h6>
                  </div>
                  <div className="notes-body">
                    <p className="mb-0">
                      <i className="fas fa-quote-left me-2 text-muted"></i>
                      {bookingDetails.notes}
                      <i className="fas fa-quote-right ms-2 text-muted"></i>
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Footer Information */}
            <div className="footer-section">
              <div className="footer-info">
                <div className="row">
                  <div className="col-md-6">
                    <div className="meta-info">
                      <span className="meta-item">
                        <i className="far fa-calendar-plus me-2 text-muted"></i>
                        {t("created")}:{" "}
                        {bookingDetails?.created_at
                          ? formatDateToLocal(bookingDetails.created_at)
                          : "N/A"}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6 text-end">
                    <div className="meta-info">
                      {bookingDetails?.updated_at && (
                        <span className="meta-item">
                          <i className="far fa-calendar-check me-2 text-muted"></i>
                          {t("updated")}:{" "}
                          {formatDateToLocal(bookingDetails.updated_at)}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-0">
          <div className="d-flex justify-content-between align-items-center w-100 flex-wrap gap-2">
            {!["cancelled", "completed", "expired"].includes(
              bookingDetails?.status,
            ) && (
              <div className="d-flex gap-2">
                {bookingDetails?.driver &&
                  bookingDetails?.status === "scheduled" && (
                    <Button
                      className="btn btn-primary px-3"
                      onClick={() => setShowUnassignConfirm(true)}
                    >
                      Unassign Driver
                    </Button>
                  )}
                {role === "school" && (
                  <Button
                    className="btn btn-primary px-3"
                    onClick={() => {
                      setReservationId(bookingDetails?.id);
                      setCharterFrequency(bookingDetails?.charter_frequency);
                      setShowCancelModal(true);
                    }}
                  >
                    {t("cancel")} {t("reservation")}
                  </Button>
                )}
              </div>
            )}
            <Button
              className="btn btn-primary px-4 ms-auto"
              onClick={handleCloseDetail}
            >
              <i className="fas fa-times me-2"></i>
              {t("btns.close")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <UnassignDriverModal
        show={showUnassignConfirm}
        onHide={() => setShowUnassignConfirm(false)}
        reservationId={bookingDetails?.id}
        driverName={
          bookingDetails?.driver?.full_name || bookingDetails?.driver_name
        }
        onSuccess={() => {
          setShowDetail(false);
          refetch();
        }}
      />

      {/* delete model */}
      <Modal show={show}>
        <Button className="closePopup" onClick={() => setShow(false)}>
          <IoCloseSharp />
        </Button>
        <div className="popupBox p-3 p-md-5">
          <div>
            <div className="text-center mb-3 errorIcon">
              <BiSolidError />
            </div>
            <div className="text-center mb-4 deleteHd">
              {t("delete-modal")}?
            </div>
            <div className="text-center">
              <Button
                className="smallBtn cancel me-3"
                onClick={() => setShow(false)}
              >
                {t("btns.cancel")}
              </Button>
              <Button
                className="smallBtn auto"
                disabled={isDeleteLoading}
                onClick={handleDelete}
              >
                {isDeleteLoading ? (
                  <div className="spinner-border" role="status">
                    <span className="sr-only p-0"></span>
                  </div>
                ) : (
                  t("btns.delete")
                )}
              </Button>
            </div>
          </div>
        </div>
      </Modal>

      {/* confirmation modal for booking cancel */}
      <Modal show={bookingCancelModal}>
        <Button className="closePopup" onClick={handleCloseBookingCancelModal}>
          <IoCloseSharp />
        </Button>
        <div className="popupBox p-3 p-md-5">
          <div>
            <div className="text-center mb-3 errorIcon">
              <BiSolidError />
            </div>
            <div className="text-center mb-4 deleteHd">
              {t("cancel-reservation")}
            </div>
            <div className="text-center">
              <Button
                className="smallBtn cancel me-3"
                onClick={handleCloseBookingCancelModal}
              >
                {t("no")}
              </Button>
              <Button
                className="smallBtn auto"
                disabled={isUpdateLoading}
                onClick={handleRideCancel}
              >
                {isUpdateLoading ? (
                  <div className="spinner-border" role="status">
                    <span className="sr-only p-0"></span>
                  </div>
                ) : (
                  t("yes")
                )}
              </Button>
            </div>
          </div>
        </div>
      </Modal>

      {editModelShow && (
        <Modal
          show={editModelShow}
          onHide={handleEditModelClose}
          size="lg"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton className="border-0">
            <Modal.Title className="h5">{t("reservations")}</Modal.Title>
          </Modal.Header>
          <BusCharter
            selectedReservation={selectedReservation}
            onClose={handleEditModelClose}
          />
        </Modal>
      )}

      <CancelReservation
        showCancelModal={showCancelModal}
        handleCloseCancelModal={handleCloseCancelModal}
        handleCancelReservation={handleCancelReservation}
        reservationId={reservationId}
        charterFrequency={charterFrequency}
        endPoint="bus-charter"
      />

      <style>{`
        .detailModel .modal-dialog {
          max-width: 900px;
        }

        .header-card {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          padding: 15px 20px;
          border-radius: 10px;
          border-left: 4px solid #f0b342;
        }
        .info-card {
          background: #fff;
          border-radius: 10px;
          border: 1px solid #e0e0e0;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
          overflow: hidden;
        }

        .info-header {
          background: #f8f9fa;
          padding: 12px 15px;
          border-bottom: 1px solid #e0e0e0;
          display: flex;
          align-items: center;
        }

        .info-body {
          padding: 15px;
        }

        .info-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
          border-bottom: 1px dashed #f0f0f0;
        }

        .info-item:last-child {
          border-bottom: none;
        }

        .info-label {
          color: #666;
          font-size: 14px;
          display: flex;
          align-items: center;
        }

        .info-value {
          color: #333;
          font-weight: 500;
          text-align: right;
          max-width: 60%;
          word-break: break-word;
        }

        .location-card {
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          height: 100%;
        }

        .location-header {
          padding: 12px 15px;
          font-weight: 600;
          font-size: 15px;
          display: flex;
          align-items: center;
        }

        .location-body {
          padding: 15px;
          background: #fff;
          min-height: 80px;
          display: flex;
          align-items: center;
        }

        .location-body p {
          color: #444;
          font-size: 14px;
          line-height: 1.5;
        }

        .notes-card {
          background: #fff;
          border-radius: 10px;
          border: 1px solid #e0e0e0;
          overflow: hidden;
        }

        .notes-header {
          background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
          padding: 12px 15px;
          border-bottom: 1px solid #e0e0e0;
          display: flex;
          align-items: center;
        }

        .notes-body {
          padding: 15px;
          background: #fafafa;
          font-style: italic;
          color: #555;
        }

        .footer-section {
          margin-top: 20px;
          padding-top: 15px;
          border-top: 1px dashed #ddd;
        }

        .meta-info {
          display: flex;
          align-items: center;
        }

        .meta-item {
          font-size: 13px;
          color: #777;
          display: inline-flex;
          align-items: center;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .info-item {
            flex-direction: column;
            align-items: flex-start;
          }

          .info-value {
            text-align: left;
            margin-top: 4px;
            max-width: 100%;
          }

          .location-section .col-md-6 {
            margin-bottom: 15px;
          }
        }

        /* Icon colors */
        .text-primary {
          color: #007bff !important;
        }
        .text-success {
          color: #28a745 !important;
        }
        .text-warning {
          color: #ffc107 !important;
        }
        .text-danger {
          color: #dc3545 !important;
        }
        .text-info {
          color: #17a2b8 !important;
        }
      `}</style>
    </>
  );
};

export default BusCharterList;
